import { routes } from '../app/appMainRoutes';

const root = routes.enrichment;
const mappingRoute = `${root}/mappings`;

export const enrichmentRoutes = {
  root,
  company: `${mappingRoute}/company`,
  contact: `${mappingRoute}/contact`,
};

export const filterableListFields = ['name', 'objectType', 'id'];
